import { Box } from '@mui/material';
import colors from '../../assets/colors';

export default function GreenBorderBox(props) {
  const sxProps = { ...props.sx };
  return (
    <>
      <Box
        sx={{
          mt: 5,
          borderRadius: 4,
          border: `1.5px solid ${colors.agroweGreen}`,
          minHeight: 100,
          p: 3,
          ...sxProps,
        }}
        component="fieldset"
      >
        {props.children}
      </Box>
    </>
  );
}
